export default "__VITE_ASSET__dcaba38c__"